/*! Agile Pixel https://agilepixel.io - 2021*/
/*
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Cookies from 'js-cookie';

gsap.registerPlugin(ScrollTrigger);
 */
export default {
  init() {
    //Check for collisions

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    /*     const cookieButton = document.querySelector('.js-cookie__action');
    const cookieContainer = document.querySelector('.js-cookie');
    cookieButton.addEventListener('click', () => {
      Cookies.set('cookie-policy', 'true');
      cookieContainer.classList.add('is-active');
    }); */
  },
};
